


















































































































































import Vue, { PropType } from "vue";
import moment from "moment-timezone";
import { createNamespacedHelpers } from "vuex";
import { Client } from "@/types";

// import appointmentStoreModule from "@/store/modules/appointment";

const { mapActions: appointmentActions } =
  createNamespacedHelpers("APPOINTMENT_LIST");

export default Vue.extend({
  name: "AppointmentDateFilter",
  props: {
    client: {
      type: Object as PropType<Client>,
    },
  },
  data: () => ({
    displayRange: "All Data",
    currentRangeType: "all",
    currentDate: moment(),
    startDate: null as string | null,
    endDate: null as string | null,
    type: "all",
    activeRange: null as string | null, // Default value for the button toggle
    start: {} as { date?: string; day?: number; year?: number },
    end: {} as { date?: string; day?: number; year?: number },
    startDateMenu: false,
    endDateMenu: false,
    status: [] as string[],
    paymentStatus: [] as string[],
  }),
  computed: {
    formattedStartDate(): string {
      return this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : "";
    },
    formattedEndDate(): string {
      return this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : "";
    },
  },
  mounted() {
    this.$emit("rangeChange", {
      start: null,
      end: null,
    });
  },
  watch: {
    activeRange(v) {
      if (this.type === "all") {
        this.type = v;
      }
      this.currentRangeType = v;
      this.updateDateRange();
    },
    status: {
      handler(newVal) {
        this.$emit("statusChange", newVal);
        this.fetchAppointments();
      },
      immediate: true,
    },
    paymentStatus: {
      handler(newVal) {
        this.$emit("paymentStatusChange", newVal);
        this.fetchAppointments();
      },
      immediate: true,
    },
  },
  methods: {
    ...appointmentActions(["fetchAppointmentList", "fetchAppointmentCount"]),
    handleAllClick() {
      this.type = "all";
      this.startDate = null;
      this.endDate = null;
      this.resetToAllData();
    },
    resetToAllData() {
      this.startDate = null;
      this.endDate = null;
      this.displayRange = "All Data";
      this.start = {};
      this.end = {};
      this.$emit("rangeChange", {
        start: null,
        end: null,
      });
    },
    navigateNext() {
      switch (this.currentRangeType) {
        case "month":
          this.currentDate.add(1, "month");
          break;
        case "week":
          this.currentDate.add(1, "week");
          break;
        case "day":
          this.currentDate.add(1, "day");
          break;
      }
      this.updateDateRange();
    },
    navigatePrevious() {
      switch (this.currentRangeType) {
        case "month":
          this.currentDate.subtract(1, "month");
          break;
        case "week":
          this.currentDate.subtract(1, "week");
          break;
        case "day":
          this.currentDate.subtract(1, "day");
          break;
      }
      this.updateDateRange();
    },
    updateDateFromPicker(type: "start" | "end") {
      if (type === "start") {
        this.currentDate = moment(this.startDate);
      } else {
        this.currentDate = moment(this.endDate);
      }

      // Update display range without changing the mode
      this.updateDisplayRange();
      this.syncDatesToObjects();
      this.emitDateRange();
    },
    updateDisplayRange() {
      if (this.startDate && this.endDate) {
        const start = moment(this.startDate);
        const end = moment(this.endDate);

        if (start.isSame(end, "day")) {
          this.displayRange = start.format("MMMM Do YYYY");
        } else {
          this.displayRange = `${start.format("MMMM Do YYYY")} - ${end.format(
            "MMMM Do YYYY"
          )}`;
        }
      } else if (this.type === "all" && !this.startDate && !this.endDate) {
        this.displayRange = "All Data";
      }
    },
    syncDatesToObjects() {
      if (this.startDate) {
        this.start.date = moment(this.startDate).format("YYYY-MM-DD");
        this.start.day = moment(this.startDate).date();
        this.start.year = moment(this.startDate).year();
      } else {
        this.start = {};
      }
      if (this.endDate) {
        this.end.date = moment(this.endDate).format("YYYY-MM-DD");
        this.end.day = moment(this.endDate).date();
        this.end.year = moment(this.endDate).year();
      } else {
        this.end = {};
      }
    },
    emitDateRange() {
      const startDate = this.startDate
        ? moment(this.startDate).startOf("day").toISOString()
        : null;

      const endDate = this.endDate
        ? moment(this.endDate).endOf("day").toISOString()
        : null;
      this.$emit("rangeChange", {
        start: startDate,
        end: endDate,
      });
    },
    updateDateRange() {
      switch (this.currentRangeType) {
        case "month":
          this.startDate = this.currentDate
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD");
          this.endDate = this.currentDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD");
          this.displayRange = moment(this.startDate).format("MMMM YYYY");
          break;
        case "week":
          this.startDate = this.currentDate
            .clone()
            .startOf("isoWeek")
            .format("YYYY-MM-DD");
          this.endDate = this.currentDate
            .clone()
            .endOf("isoWeek")
            .format("YYYY-MM-DD");
          this.displayRange = `${moment(this.startDate).format(
            "MMMM Do YYYY"
          )} - ${moment(this.endDate).format("MMMM Do YYYY")}`;
          break;
        case "day":
          this.startDate = this.currentDate
            .clone()
            .startOf("day")
            .format("YYYY-MM-DD");
          this.endDate = this.currentDate
            .clone()
            .endOf("day")
            .format("YYYY-MM-DD");
          this.displayRange = moment(this.startDate).format("MMMM Do YYYY");
          break;
      }
      this.syncDatesToObjects();
      this.emitDateRange();
      this.fetchAppointments();
    },
    fetchAppointments() {
      let params = `?businessId=${localStorage.getItem("businessId")}`;

      if (this.client) {
        params += `&clientId=${this.client._id}`;
      }

      // if (this.options.itemsPerPage && this.options.itemsPerPage > 1) {
      //   params += `&limit=${this.options.itemsPerPage}`;
      // }

      if (this.status.length > 0) {
        params += `&status=${this.status
          .map((s) => s.toLowerCase())
          .join("&status=")}`;
      }

      if (this.paymentStatus.length > 0) {
        params += `&paymentStatus=${this.paymentStatus
          .map((s) => s.toLowerCase())
          .join("&paymentStatus=")}`;
      }

      if (this.startDate) {
        // this.startDate.hours(23).minutes(59).seconds(59);
        // this.endDate.hours(23).minutes(59).seconds(59);
        params += `&startDate=${this.startDate}`;
      }

      if (this.endDate) {
        // this.startDate.hours(23).minutes(59).seconds(59);
        // this.endDate.hours(23).minutes(59).seconds(59);
        params += `&endDate=${this.endDate}`;
      }
      this.fetchAppointmentCount(`${params}`);

      this.fetchAppointmentList(params);
    },
  },
  beforeCreate() {
    // if (this.$store.hasModule("APPOINTMENT_LIST")) {
    //   this.$store.unregisterModule("APPOINTMENT_LIST");
    // }
    // this.$store.registerModule("APPOINTMENT_LIST", appointmentStoreModule);
  },
});
